import { clients, Scope } from '@moovly/clients';
import { ProfilePreview } from '@moovly/dashboard-global';
import { t } from '@moovly/i18n';
import { RestrictedTo } from '@moovly/permissions';
import { Button, IconExternalLink } from '@moovly/ui';
import * as React from 'react';
import useCurrentUser from '../../../hooks/useCurrentUser';

const ProfileContainer: React.FC = () => {
  const { user } = useCurrentUser();
  const [license, setLicense] = React.useState<any>();

  React.useEffect(() => {
    clients.Licenses.getUserLicense().then(setLicense);
  }, []);
  return (
    <div>
      {!!user && !!license && (
        <ProfilePreview profile={user} license={license}>
          <RestrictedTo scope={Scope.usersUpdate}>
            <Button
              href="https://dashboard.moovly.com/settings/profile/edit"
              target="_blank"
              color="pink"
              className="mt-4"
              label={t('profile.editProfileBtn')}
              icon={IconExternalLink}
            />
          </RestrictedTo>
        </ProfilePreview>
      )}
      <hr />
    </div>
  );
};
export default ProfileContainer;
